import React, { useState, useEffect, useContext } from "react";
import {
  Grid,
  Dialog,
  IconButton,
  DialogContent,
  InputAdornment,
  TextField,
  makeStyles,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from "@material-ui/icons/Check";
import { useTranslation } from "react-i18next";
import { updateAssociationAttribute } from "../../../../../../API/Entity";
import { LoadingIndicator } from "../../../../../../Component";
import ModalDialogContext from "../../../../../../Context/ModalDialog/ModalDialogContext";
import styles from "./styles";

const useStyles = makeStyles(styles);

const OwnershipPercentageDialog = (props) => {
  const { isDialogOpen, onClose, connector = {}, currentSourceTotal, onLabelUpdate } = props;
  const classes = useStyles();

  const [isLoading, setIsLoading] = useState(false);
  const [percentage, setPercentage] = useState(0);
  const [percentageErrorMessage, setPercentageErrorMessage] = useState();

  const { t } = useTranslation();

  const { showErrorMessage } = useContext(ModalDialogContext);

  useEffect(() => {
    if (connector) {
      setPercentage(connector.value || 0);
    }

  }, [connector, currentSourceTotal]);

  const ownershipChange = (event) => {
    const val = Math.min(100, event.target.value);
    setPercentage(val);
  };

  const renderLoadingIndicator = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <LoadingIndicator />
      </div>
    );
  };

  const handleClose = (status) => {
    if (onClose) {
      onClose(status);
    }
  };

  const cancel = () => {
    handleClose("cancel");
  }

  const validate = () => {
    if ((currentSourceTotal - connector.value) + percentage > 100) {
      setPercentageErrorMessage(t("messages.record.associations.ownershipPercentageError"));
      return false;
    }
    return true;
  };

  const update = async () => {
    if (!validate()) {
      return;
    }
    setIsLoading(true);
    try {
      await updateAssociationAttribute({
        sourceEntityId: connector.sourceRec.id,
        targetEntityId: connector.targetRec.id,
        associationId: "2",
        attributeId: "81",
        dataType: "N",
        value: `${percentage}`
      }
      );
      onLabelUpdate();
    } catch (error) {
      showErrorMessage({ error });
    }
    setIsLoading(false);
    handleClose();
  };

  const renderCreateForm = () => {
    return (
      <Grid container spacing={3}>
        <Grid item container xs={12} justify="center">
          <Typography component="span" className={classes.recordName}>
            {(connector.targetRec || {}).recordName}
          </Typography>
        </Grid>
        <Grid item container xs={12} alignContent="center">
          <Grid item xs={6}>
            {t("labels.record.ownershipStructure.ownershipPercentage")}
          </Grid>
          <Grid item xs={3}>
            <TextField
              type="number"
              variant="outlined"
              onChange={ownershipChange}
              value={percentage}
              margin="none"
              size="small"
              InputProps={{
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
              }}
              inputProps={
                {
                  max: 100,
                  min: 0,
                  step: 1
                }
              }
            />
          </Grid>
          {!isLoading && <Grid item container xs={3} alignContent="center">
            <IconButton
              aria-label="save"
              className={classes.iconButton}
              onClick={update}>
              <CheckIcon htmlColor={"red"} />
            </IconButton>
            <IconButton
              aria-label="Close"
              className={classes.iconButton}
              onClick={cancel}
            >
              <CloseIcon />
            </IconButton>
          </Grid>}
          {isLoading && <Grid item container xs={3} alignContent="center">
            {renderLoadingIndicator()}
          </Grid>}
        </Grid>
        <Grid item container xs={12}>
          <span className={classes.errorText}>{percentageErrorMessage}</span>
        </Grid>
      </Grid>
    );
  };

  return (
    <Dialog
      disableBackdropClick
      onClose={cancel}
      aria-labelledby="update-ownership-percentage"
      open={isDialogOpen}
      maxWidth="xs"
    >
      <DialogContent dividers>
        {renderCreateForm()}
      </DialogContent>
    </Dialog>
  );
};

export default OwnershipPercentageDialog;
